import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from '@app/store/slices/userSlice';
import myTeamReducer, { myTeamListener } from '@app/store/slices/myTeamSlice';
import myUsersReducer, {
  myUsersListener,
} from '@app/store/slices/myUsersSlice';
import cardsReducer, { cardsListener } from '@app/store/slices/cardsSlice';
import groupIdReducer, {
  groupIdListener,
} from '@app/store/slices/groupIdSlice';
import referralsReducer from '@app/store/slices/referralsSlice';
import preloaderReducer from '@app/store/slices/preloaderSlice';
import balancesReducer, {
  balancesListener,
} from '@app/store/slices/balancesSlice';
import configsReducer from '@app/store/slices/configsSlice';
import transactionsReducer, {
  transactionsListener,
} from '@app/store/slices/transactionsSlice';
import withdrawChannelsReducer from '@app/store/slices/withdrawChannelsSlice';
import tariffReducer from '@app/store/slices/tariffSlice';
import notificationsReducer from '@app/store/slices/notificationsSlice';
import bankWalletsReducer from '@app/store/slices/bankWalletsSlice';
import declineRateReducer from '@app/store/slices/declineRateSlice';

const persisted = (key, reducer, whitelist = ['params', 'search']) =>
  persistReducer({ key, storage, whitelist }, reducer);

const appReducer = combineReducers({
  user: userReducer,
  my_team: persisted('my_team', myTeamReducer),
  my_users: persisted('my_users', myUsersReducer),
  group_id: persisted('group_id', groupIdReducer, ['params']),
  cards: persisted('cards', cardsReducer),
  referrals: referralsReducer,
  preloader: preloaderReducer,
  balances: persisted('balances', balancesReducer),
  transactions: persisted('transactions', transactionsReducer),
  configs: configsReducer,
  withdrawChannels: withdrawChannelsReducer,
  tariff: tariffReducer,
  notifications: notificationsReducer,
  bankWallets: bankWalletsReducer,
  declineRate: declineRateReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'logout') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(
      myTeamListener.middleware,
      myUsersListener.middleware,
      groupIdListener.middleware,
      cardsListener.middleware,
      balancesListener.middleware,
      transactionsListener.middleware,
    ),
});

export const persistor = persistStore(store);
